import { Badge, Button, Drawer, IconButton, ThemeProvider } from '@mui/material';
import { topBarHeight } from 'app/utils/constant';
//import { getTimeDifference } from 'app/utils/utils.js';
import React, { useState, useEffect, Fragment } from 'react';

import { useSelector } from 'react-redux';
import {useNavigate } from 'react-router-dom';
import ItemList from 'app/components/ItemList';
import Icon from 'app/components/Icon';
import { useWindowSize } from "app/hooks/useWindowSize";

const NotificationBar = ({ container, badge, icon, iconActive, title, url, viewMore = null, renderItem, component = null, nolimit = false, maxLimit=true, limit=10, reload = false, hideLoading =false, onCounter, onActionCall, buttons, onRemove, emptyText = null, skeleton = null, filterItems = null }) => {

  const settings = useSelector(store=>store.settings);
  const rcounter = useSelector(store=>store.counter);

  //const theme = useTheme();
  const navigate = useNavigate();
  const windowSize = useWindowSize();

  //const secondary = theme.palette.text.secondary;
  const [panelOpen, setPanelOpen] = React.useState(false);
  const [counter,setCounter] = useState(0);
  const [opended,setOpended] = useState(false);
  const [itemsHeight,setItemsHeight] = useState(0);
  const [show,setShow] = useState(true);
  const btnHeight = 36;
  
  if( !iconActive && icon)
    iconActive = icon;

  useEffect(()=>{
    setCounter(rcounter[badge] || 0);
  },[rcounter,badge]);

  useEffect(()=>{
    setItemsHeight(windowSize.height-topBarHeight-(viewMore ? btnHeight : 0));
  },[windowSize.height,viewMore]);

  useEffect(()=>{
    if( panelOpen ) setOpended(true);

    return ()=> {  };
  },[panelOpen]);

  const handleDrawerToggle = () => {
    setPanelOpen(!panelOpen);
    if( panelOpen ) onClose();
  };

  const onViewMore = ()=>{
    navigate('/'+viewMore);
    setPanelOpen(false);
    onClose();
  }

  const onClose = () =>{
    if( reload ) setOpended(false);
  }
  
  return (
    <Fragment>
      <IconButton className="notifcation-btn" onClick={handleDrawerToggle}>
        <Badge color="primary" badgeContent={counter > 9 ?'9+' : counter}>
          <Icon>{panelOpen ? iconActive : icon}</Icon>
        </Badge>
      </IconButton>

      <ThemeProvider theme={settings.themes[settings.activeTheme]}>
        <Drawer
          width={'100px'}
          container={container}
          variant="temporary"
          anchor={'right'}
          open={panelOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
        >
          <div className="notifcation-drawer">
            <div className="close-btn" onClick={handleDrawerToggle}><Icon>times</Icon></div>
            <div className="header">
              <Icon>{iconActive}</Icon>
              <h5>{title}{counter > 0 ?  <span> ({counter})</span>: null}</h5>
            </div>
            {opended && <ItemList 
              url={url}
              emptyText={emptyText || "No items"} 
              columns={1} 
              spacing={0}
              height={itemsHeight}
              hideLoading={hideLoading}
              boxPadding={0}
              limit={limit}
              errorMargin={20}
              maxLimit={maxLimit ? limit : null}
              skeleton={skeleton}
              renderItem={(item,idx,buttons)=>renderItem(item,idx,buttons,setPanelOpen)} 
              onLoad={total=>{
                setShow(false);
                setTimeout(()=>setShow(true),0);
                if( onCounter ) onCounter(total);
              }}
              filterItems={filterItems}
              renderData={component ? (state,gs)=>component(state,gs,handleDrawerToggle,show) : null}
              buttons={buttons}
              onRemove={onRemove}
              onActionCall={onActionCall}
            />}

            {viewMore && <Button className="view-more" onClick={()=>onViewMore()} sx={{ height: btnHeight}}>View All</Button>}
          </div>
        </Drawer>
      </ThemeProvider>
    </Fragment>
  );
};

export default NotificationBar;
